import { useEffect, useState } from "react";

import {
  generateSignedM3u8Url,
  generateSignedUrl,
} from "./generatePreSignedUrl";
import {
  parseM3u8ForLastThumbnail,
  parseM3u8ToExtractThumbnailManifestFileName,
} from "./m3u8Parser";

import type { Cookie } from "@spwn/types/functions";

/** サムネイルURL取得のポーリング間隔（ミリ秒） */
const POLLING_INTERVAL_MS = 5000;

export const useGetVideoThumbnailPresignedUrl = ({
  url: cookieUrl,
  cookie,
}: Pick<Cookie, "url" | "cookie">): string | undefined => {
  const [thumbnailUrl, setThumbnailUrl] = useState<string | undefined>(
    undefined
  );

  useEffect(() => {
    const fetchData = async (): Promise<void> => {
      try {
        const manifestFileUrl = generateSignedM3u8Url(cookieUrl, cookie);
        const response = await fetch(manifestFileUrl);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const manifestFileData = await response.text();
        const thumbnailManifestFileName =
          parseM3u8ToExtractThumbnailManifestFileName(manifestFileData);

        if (!thumbnailManifestFileName) {
          console.warn("No thumbnail manifest file name found.");
          return;
        }

        const thumbnailIndexUrl = generateSignedUrl({
          manifestFileUrl: cookieUrl,
          cookie,
          fileName: thumbnailManifestFileName,
        });

        const thumbnailManifestFileResponse = await fetch(thumbnailIndexUrl);

        if (!thumbnailManifestFileResponse.ok) {
          throw new Error(
            `HTTP error! status: ${thumbnailManifestFileResponse.status}`
          );
        }
        const thumbnailManifestFileData =
          await thumbnailManifestFileResponse.text();
        const lastFileName = parseM3u8ForLastThumbnail(
          thumbnailManifestFileData
        );

        if (!lastFileName) {
          console.warn("No last thumbnail file name found.");
          return;
        }

        const lastThumbnailUrl = generateSignedUrl({
          manifestFileUrl: cookieUrl,
          cookie,
          fileName: lastFileName,
        });

        setThumbnailUrl(lastThumbnailUrl);
      } catch (error) {
        console.error("error happened in useGetPresignedUrl", error);
      }
    };
    // 初回実行
    void fetchData();

    // ポーリング実行
    const intervalId = setInterval(() => {
      void fetchData();
    }, POLLING_INTERVAL_MS);

    // クリーンアップ
    return () => clearInterval(intervalId);
  }, [cookieUrl, cookie]);

  return thumbnailUrl;
};
